import { useState } from 'react';
import Hero from '../../../components/Hero';
import Lectures from './components/Lectures';
import RedeemForm from './components/RedeemForm';

function VouchersRedeem() {
  const [redeemdLectures, setRedeemdLectures] = useState(null);
  const [lecturesToRedeem, setLecturesToRedeem] = useState(null);
  const [code, setCode] = useState(null);

  return (
    <>
      <Hero
        title="شراء عن طريق الكود"
        description="يمكنك إدخال كود الشراء الخاص بالمحاضره او العرض "
        pagesLinks={[
          {
            name: 'شراء عن طريق الكود',
            link: `/redeem`,
          },
          {
            name: 'الصفحة الرئيسية',
            link: `/`,
          },
        ]}
      />
      <RedeemForm
        setRedeemdLectures={setRedeemdLectures}
        setLecturesToRedeem={setLecturesToRedeem}
        setCode={setCode}
      />

      {(redeemdLectures || lecturesToRedeem) && (
        <Lectures redeemdLectures={redeemdLectures ?? lecturesToRedeem} code={code} />
      )}
    </>
  );
}

export default VouchersRedeem;
